/**
 * Rasterize a DOM node onto an A4 PDF so the download matches on-screen layout.
 */
export async function exportElementToA4Pdf(
  element: HTMLElement,
  fileName: string,
): Promise<void> {
  const [{ default: html2canvas }, { default: jsPDF }] = await Promise.all([
    import('html2canvas'),
    import('jspdf'),
  ]);

  const canvas = await html2canvas(element, {
    scale: 2,
    backgroundColor: '#ffffff',
    useCORS: true,
    logging: false,
    // Capture layout as painted (including borders / padding).
    scrollX: 0,
    scrollY: 0,
  });

  const imgData = canvas.toDataURL('image/jpeg', 0.98);
  const pdf = new jsPDF({ orientation: 'portrait', unit: 'mm', format: 'a4' });
  const pageW = pdf.internal.pageSize.getWidth();
  const pageH = pdf.internal.pageSize.getHeight();

  // Always fit on a single A4 page (scale down if content is taller).
  let imgW = pageW;
  let imgH = (canvas.height * imgW) / canvas.width;
  if (imgH > pageH) {
    const scale = pageH / imgH;
    imgW = pageW * scale;
    imgH = pageH;
  }
  const x = (pageW - imgW) / 2;
  pdf.addImage(imgData, 'JPEG', x, 0, imgW, imgH);

  const safeName = fileName.replace(/\.pdf$/i, '');
  pdf.save(`${safeName}.pdf`);
}
